import React from 'react';
import { useAuth } from '../AuthContext';

const Profile = () => {
  const { user } = useAuth();

  if (!user) {
    return <div className="text-center mt-10">You must be logged in to view your profile.</div>;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-soft">
        <h2 className="text-2xl font-bold mb-4 text-center">Profile</h2>
        <div className="text-lg mb-2">Welcome, <span className="font-semibold">{user.email}</span>!</div>
        <div className="text-gray-600">This is your profile page.</div>
      </div>
    </div>
  );
};

export default Profile; 